import React from 'react'
import { StyledListWrapper } from '../style'
import { FlexCenter } from 'components'
import { StyledEmptyList } from '../../../styled'

/**
 * Shows an empty transactions list
 * @returns
 */
const EmptyTransactionsList: React.FC = () => {
  return (
    <StyledListWrapper>
      <FlexCenter>
        <StyledEmptyList>Your transactions will appear here.</StyledEmptyList>
      </FlexCenter>
    </StyledListWrapper>
  )
}
export default EmptyTransactionsList
